/**
 * EventEnvelope — canonical event shape for ORCH-1 EventBus messages.
 */
import { z } from 'zod';

export const EventEnvelope = z.object({
  id:            z.string(),           // ULID
  type:          z.string(),           // e.g. 'load.status.changed'
  tenantId:      z.string(),
  correlationId: z.string().optional(),
  actor:         z.string().optional(), // userId or 'system'
  payload:       z.record(z.string(), z.any()),
  timestamp:     z.string(),           // ISO-8601
  schemaVersion: z.number().int().default(1),
}).passthrough();

/** @typedef {import('zod').infer<typeof EventEnvelope>} EventEnvelopeType */
